module.exports = __webpack_public_path__ + "img/hyper_icon.8072e02c.png";